import { render } from "./AccordionElement.vue?vue&type=template&id=75b3b533&scoped=true"
import script from "./AccordionElement.vue?vue&type=script&lang=js"
export * from "./AccordionElement.vue?vue&type=script&lang=js"

import "./AccordionElement.vue?vue&type=style&index=0&id=75b3b533&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b3b533"]])

export default __exports__